// extracted by css-extract-rspack-plugin
module.exports =  {"item":"Template36-NUsq__item"};